export default class Maker {

    get spinner(){
        return CS.renderSpinner()
    }

    button(oo){
        let opts = {...{
                small: true,
                content: 'button...',
                attr: {},
                obj: $('<button>'),
                click: function(){},
            },...oo}
        let o = opts.obj
            .addClass('btn')
            .addClass(opts.class)
            .addClass('btn-'+opts.type)
            .attr(opts.attr)
            .html(opts.content)
            .on('click', () => { opts.click() })

        if(opts.small)
            o.addClass('btn-sm')

        return o

    }
}
